// character-count-limit.ts
import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

export const CharacterCountLimit = Extension.create({
  name: 'characterCountLimit',

  addOptions() {
    return {
      limit: 1000,
      onLimitReached: () => {},
    };
  },

  // addProseMirrorPlugins() {
  //   return [
  //     new Plugin({
  //       key: new PluginKey('characterCountLimit'),
  //       filterTransaction: (transaction: any) => {
  //         const newDoc = transaction.doc;
  //         const newText = newDoc.textContent;

  //         if (newText.length > this.options.limit) {
  //           this.options.onLimitReached();
  //           return false; // Block the input
  //         }

  //         return true;
  //       },
  //     }),
  //   ];
  // },
   addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('characterCountLimit'),
        filterTransaction: (transaction, state) => {
          if (!transaction.docChanged) {
            return true // allow non-document changes (like selection)
          }

          const oldSize = state.doc.textContent.length
          const newSize = transaction.doc.textContent.length

          if (newSize > this.options.limit) {
            // Only block if this was an *insertion*
            if (newSize > oldSize) {
              this.options.onLimitReached?.()
              return false
            }
          }

          return true
        },
      }),
    ]
  },
  
});

export default CharacterCountLimit;
